// EDCL-350 (RS) -> utils/constant.js
const FOLDER_NAME = 'ZebraStorage';
const BULK_DELETE_ID = 'bulk';
const DEFAULT_PAGE_SIZE = 25;
const DEBOUNCE_DELAY = 500;
const API_VERSION_V1 = 'v1';
const API_VERSION_V2 = 'v2';
const STORAGE_ENDPOINT = `/storage/${API_VERSION_V1}`;
const ALLOWED_EXTENSIONS_ENDPOINT = 'allowed-file-extensions';
const SECURE_LINK_ENDPOINT = 'secure-link';
const SECURE_LINK_FILES = 'files';
const BULK_DELETE_ENDPOINT = 'bulk-delete';
const INVALID_FILE_ERROR_MESSAGE = 'Invalid file';
const FILE_TYPE_NOT_ALLOWED_ERROR_MESSAGE = 'File type is not allowed';
const FILE_NAME_LENGTH_ERROR_MESSAGE = 'File name exceeds the maximum allowed length';
const DEFAULT_TIMEOUT_MS = 60000;
const ERROR_CODES = {
    TIMEOUT: "ECONNABORTED"
}

// Pagination configuration for file list display
const PAGINATION_CONFIG = {
    labelPrefix: 'File(s)',
    pageSizeOptions: ['10', '25', '50', '100'],
};

const POP_CONFIRM_CONFIG = {
    confirmText: "Confirm",
    default: {
        title: 'Are you sure?',
        description: 'This action cannot be undone.',
        okText: 'Yes',
        width: 220,
    },
    deleteFile: {
        title: 'Delete this file?',
        description: '⚠️ This action is permanent and cannot be undone.',
        okText: 'Delete',
        width: 220,
    },
    deleteSelected: {
        title: 'Delete selected files?',
        description: '⚠️ This action is permanent and cannot be undone.',
        okText: 'Delete',
        width: 220,
    },
};

module.exports = {
    FOLDER_NAME,
    BULK_DELETE_ID,
    DEFAULT_PAGE_SIZE,
    DEBOUNCE_DELAY,
    API_VERSION_V1,
    API_VERSION_V2,
    STORAGE_ENDPOINT,
    ALLOWED_EXTENSIONS_ENDPOINT,
    SECURE_LINK_ENDPOINT,
    SECURE_LINK_FILES,
    BULK_DELETE_ENDPOINT,
    INVALID_FILE_ERROR_MESSAGE,
    FILE_TYPE_NOT_ALLOWED_ERROR_MESSAGE,
    FILE_NAME_LENGTH_ERROR_MESSAGE,
    PAGINATION_CONFIG,
    POP_CONFIRM_CONFIG,
    DEFAULT_TIMEOUT_MS,
    ERROR_CODES
};